module.exports = __webpack_public_path__ + "img/Android_Female_Happy_idle_.ec7bbb6a.png";